"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TornadoAbilityHandler = exports.TornadoActorAbilityFactory = exports.TornadoAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class TornadoAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Tornado;
        this.__typeName = "Tornado";
    }
}
exports.TornadoAbilityArgs = TornadoAbilityArgs;
let TornadoActorAbilityFactory = class TornadoActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Tornado", "AllEnemies", 1);
    }
};
TornadoActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Tornado")
], TornadoActorAbilityFactory);
exports.TornadoActorAbilityFactory = TornadoActorAbilityFactory;
let TornadoAbilityHandler = class TornadoAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            attackType: "magic",
            abilityKey: ability.args.__typeName,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                jitter: (0, Random_1.random)(20, 200),
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 50)
                ],
            })),
            sequence,
            onHit(sequence, target) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet"), "FrostTornado"));
            },
        });
    }
};
TornadoAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Tornado)
], TornadoAbilityHandler);
exports.TornadoAbilityHandler = TornadoAbilityHandler;
